import React from 'react'
import { PieChart } from './PieChart';
import {
  View,
  StyleSheet
} from 'react-native';
import Theme from '../../theme';

export class TrackingPieChartDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      labelWidth: 0
    }
  }

  render() {
    const data = JSON.parse(JSON.stringify(this.props.data));
    delete data.total;
    const result = [];
    Object.keys(this.props.data).forEach(function (key) {
      result.push({ type: key, value: data[key] });
    });
    const pieData = result
      .filter((value: any) => value.value > 0)
      .map((value: any, index: any) => ({
        value: value.value,
        color: value.type === 'burn' ? Theme.GREY : Theme.GREY_DARK_MEDIUM,
        key: `pie-${index}`,
      }))

    return (
      <View style={styles.pieChartContainer}>
        <PieChart radius={60} strokeWidth={20} data={pieData} textStyle={{fontSize: 35}}/>
      </View>
    )
  }
}
const textOffset = 10;
const textWidth = 140 - (textOffset * 2);
const textHeight = 132 * (1 - 90 / 360) - (textOffset * 2);
const styles = StyleSheet.create({
  pieChartContainer: {
    justifyContent: 'center',
    alignContent: 'center',
    marginBottom: 15,
  },
  total: {
    position: 'absolute',
    color: Theme.WHITE,
    fontSize: 34,
    fontFamily: Theme.Custom700,
    textAlign: 'center'
  },
  pieChart: {
    height: 132,
    width: 140,
  },
  textView: {
    position: 'absolute',
    top: 25,
    left: textOffset,
    width: textWidth,
    height: textHeight,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    fontSize: 26,
    color: 'white',
    fontFamily: Theme.Custom700,
  },
});